import { ExecutionModeOptions } from '@/constants/options/execution-mode.option';
import type { ExecutionModeEnum } from '@/types/enums/execution-mode.enum';

export function getExecutionModeLabel(
    type: ExecutionModeEnum | undefined
): string {
    return ExecutionModeOptions.find(opt => opt.value === type)?.label || '';
}
